import React from 'react'
import RtBorderlessButton from '../RtBorderlessButton'
import './RtLanguageDropdownToggle.css'

const RtLanguageDropdownToggle = React.forwardRef((props, ref) => {
  return <RtBorderlessButton {...props} ref={ref} className="rt-language-dropdown-toggle" variant="dark" />
})

export default RtLanguageDropdownToggle
